import { Badge, type BadgeProps } from '@tempo-io/sui-badge';
import type { DependencySeverity } from '@/features/item-panel/components/tabs/dependencies/lib/dependencyImpact';

const BADGE_VARIANT_BY_SEVERITY: Record<DependencySeverity, BadgeProps['variant']> = {
  neutral: 'default',
  warning: 'warning',
  error: 'error',
};

type DependencyIndicatorProps =
  | { state: 'none' }
  | { state: DependencySeverity; label: string; testId?: string };

export const DependencyIndicator = (props: DependencyIndicatorProps) => {
  if (props.state === 'none') {
    return null;
  }

  return (
    <Badge
      variant={BADGE_VARIANT_BY_SEVERITY[props.state]}
      data-testid={props.testId}
      className="max-w-full whitespace-nowrap"
    >
      {props.label}
    </Badge>
  );
};
